module.exports = __webpack_public_path__ + "static/img/zd07.269849f9.svg";